import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import RegistrationKyc from "./pages/RegistrationKyc";
import ProductsPage from "./pages/ProductsPage";
import Profile from "./pages/Profile";
import VyaparSales from "./pages/VyaparSales";
import MarketingCollators from "./pages/MarketingCollators";
import AdminPanel from "./admin/AdminPanel";
import AddProductForm from "./admin/AddProductForm";
import MainLayout from "./layouts/MainLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import NotificationsPage from "./pages/NotificationsPage";
import PublicRoute from "./components/PublicRoute";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import SelectDealer from "./pages/SelectDealer";
import { getAdminSession, getViewAs, canSeeAdminPanel } from "./utils/adminView";
// PromotionalPage now serves BOTH /personal-creatives (Festival default) and
// /promotional (Promotional default). The same data source backs both views;
// the URL controls the initial Type filter.
import PromotionalPage from "./pages/PromotionalPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route element={<PublicRoute />}>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/registration-kyc" element={<RegistrationKyc />} />
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route path="/select-dealer" element={<SelectDealer />} />
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<ProductsPage />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/vyapar-sales" element={<VyaparSales />} />
            <Route path="/marketing-collators" element={<MarketingCollators />} />
            <Route path="/my-customers" element={<VyaparSales />} />
            <Route path="/personal-creatives" element={<PromotionalPage />} />
            <Route path="/promotional" element={<PromotionalPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
          <Route element={<MainLayout />}>
            <Route path="/admin-dashboard" element={<AdminPanel />} />
            <Route path="/add-product" element={<AddProductForm />} />
          </Route>
        </Route>

        <Route path="/login-success" element={<LoginSuccessRedirect />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function LoginSuccessRedirect() {
  let dealer = null;

  try {
    const raw = localStorage.getItem("dealer");
    dealer = raw ? JSON.parse(raw) : null;
  } catch {
    dealer = null;
  }

  const roleRaw = localStorage.getItem("role");

  if (!dealer || !roleRaw) {
    return <Navigate to="/" replace />;
  }

  const role = String(roleRaw).toLowerCase();

  // Admin who has not picked a dealer yet → dealer picker.
  if (getAdminSession() && !getViewAs()) {
    return <Navigate to="/select-dealer" replace />;
  }

  return (
    <Navigate
      to={role === "admin" && canSeeAdminPanel() ? "/admin-dashboard" : "/dashboard"}
      replace
    />
  );
}